import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/app/router/route-constants';
import { selectIsBackofficeAuthenticated } from '@/features/backoffice2020/store/backoffice-auth-slice';

/**
 * Restricts backoffice login from already-authenticated backoffice users.
 */
export function BackofficeGuestGuard() {
  const isAuthenticated = useAppSelector(selectIsBackofficeAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={ROUTES.BACKOFFICE2020} replace />;
  }

  return <Outlet />;
}
